import { useOrganization } from "@hooks";
import mixpanel from "mixpanel-browser";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { handleSubscribe } from "../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../constants";
import { DSButton, DSLinkButton } from "../design-system/molecules";
import { DSModal } from "../design-system/organisms";

export const UpgradePlanButton = (featureName) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const { isOrgAdmin } = useOrganization();
  const [shouldShowConfirmModal, setShouldShowConfirmModal] =
    useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    mixpanel.track("Upgrade Plan Clicked", {
      featureName,
    });
    if (isOrgAdmin) {
      setShouldShowConfirmModal(true);
      return;
    } else {
      handleSubscribe({
        priceId: UNLIMITED_PRICE_ID_MONTHLY,
        route: currentPath,
      });
    }
  };

  return (
    <>
      <DSModal
        isOpen={shouldShowConfirmModal}
        onClose={() => setShouldShowConfirmModal(false)}
        title="Just Checking In"
        dataTestId="upgrade-plan-confirm-modal"
        actions={[
          {
            label: "Go to Teams Management",
            variant: "cancel",
            onClick: () => {
              navigate("/teams");
              setShouldShowConfirmModal(false);
            },
          },
          {
            label: "Continue to Checkout",
            variant: "primary",
            onClick: () => {
              handleSubscribe({
                priceId: UNLIMITED_PRICE_ID_MONTHLY,
                route: currentPath,
              });
            },
          },
        ]}
      >
        <div className="space-y-md">
          <p className="text-primary">
            Looks like you are the admin of at least one team. If you
            are trying to add billing information for your teams, that
            can be done from the{" "}
            <DSLinkButton
              onClick={() => {
                navigate("/teams");
                setShouldShowConfirmModal(false);
              }}
              dataTestId="teams-management-link"
            >
              Teams Management Page.
            </DSLinkButton>{" "}
            If you are trying to upgrade your own account, then you
            can disregard this message and{" "}
            <DSLinkButton
              onClick={() =>
                handleSubscribe({
                  priceId: UNLIMITED_PRICE_ID_MONTHLY,
                  route: currentPath,
                })
              }
              dataTestId="continue-checkout-link"
            >
              Continue to Checkout.
            </DSLinkButton>{" "}
          </p>
          <p className="text-sm font-bold text-primary">
            *Note that upgrading your own account will not update
            billing info for any of your teams, nor will it upgrade
            the accounts of any members of your teams.
          </p>
        </div>
      </DSModal>

      <DSButton
        size="sm"
        dataTestId="upgrade-button"
        onClick={handleClick}
      >
        Upgrade Plan
      </DSButton>
    </>
  );
};
